module.exports = __webpack_public_path__ + "img/grey.1bc3af91.jpg";